import { ErrorCode } from '@planning/utils/ErrorCode/error-code-enum'
import { useTranslate } from '@tolgee/react'
import { getErrorData } from '@tom-ui/utils'

export const useGateControlMessageHandler = () => {
  const { t } = useTranslate()

  const getSuccessMessage = () => {
    return t('Success', 'Success')
  }

  const getExceptionMessage = (error: any) => {
    const errorData = getErrorData(error)

    if (errorData?.errorCode === ErrorCode.TruckAlreadyOnTerminal) {
      return t(
        'aTruckWithTheSameLicensePlateIsAlreadyOnTerminal',
        `A truck visit with the same license plate is already on terminal`,
      )
    }
    if (errorData?.errorCode === ErrorCode.ValidityDateInPast) {
      return t(
        'theVisitHasOrdersWithReleaseValidityDateInThePast',
        'The visit has orders with release validity date in the past',
      )
    }

    if (errorData?.errorCode === ErrorCode.ContainerAlreadyAssigned) {
      return t(
        'aContainerWithTheSameNumberIsAlreadyAssigned',
        `A container with the same number is already assigned to this visit`,
      )
    }

    return t('failedToSave', 'Failed to save')
  }

  return {
    getExceptionMessage,
    getSuccessMessage,
  }
}
